import React, { FC, useEffect } from 'react';

import TemplateAuthForm from 'components/auth/TemplateAuthForm';
import Button from 'components/common/ui-kit/Button';
import Input from 'components/common/ui-kit/Input';
import RouteButtonLink from 'components/common/ui-kit/RouteButtonLink';
import useSignUpCodeForm from 'hooks/auth/useSignUpCodeForm';
import useAppDispatch from 'hooks/common/useAppDispatch';
import terms from 'i18n';
import { showModal } from 'redux/actions';

type SignUpFormProps = {
  title: string;
};

const registrationStartDate = process.env.REACT_APP_REGISTRATION_START_DATE;
export const isRegistrationDisabled = registrationStartDate
  ? new Date(registrationStartDate) > new Date()
  : true;

const SignUpCodeForm: FC<SignUpFormProps> = ({ title }) => {
  const dispatch = useAppDispatch();
  const {
    fields,
    onSubmit,
    errors,
    handleResend,
    btnDisabled,
    submitDisabled,
    countdown,
  } = useSignUpCodeForm();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(e);
  };

  useEffect(() => {
    dispatch(
      showModal({
        name: 'COOKIE_MODAL',
      })
    );
  }, [dispatch]);

  return (
    <TemplateAuthForm title={title}>
      <form>
        <div className="email-form__body">
          <div className="auth-form__fields">
            <Input
              placeholder={terms.EMAIL}
              className="auth-form__input"
              {...fields['email']}
              error={errors.email?.message}
              disabled
            />
            <Input
              placeholder={terms.CODE}
              className="auth-form__input"
              {...fields['code']}
              error={errors.code?.message}
            />
          </div>
          <Button
            type="button"
            id="auth-form__register-button"
            theme="success"
            className="auth-form__button"
            onClick={handleResend}
            disabled={btnDisabled}
          >
            {btnDisabled
              ? `${terms.RESEND_CODE} (${countdown} сек)`
              : terms.RESEND_CODE}
          </Button>
        </div>

        <div className="auth-form__buttons">
          <RouteButtonLink to="/sign-up/email" className="auth-form__button">
            {terms.BACK}
          </RouteButtonLink>
          <Button
            id="auth-form__register-button"
            theme="success"
            className="auth-form__button"
            onClick={handleSubmit}
            disabled={submitDisabled}
          >
            {terms.CONTINUE}
          </Button>
        </div>
      </form>
    </TemplateAuthForm>
  );
};

export default SignUpCodeForm;
